// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"L1-z","dimensionLabel":"M1-z","styleChooserControlWrapper":"N1-z","styleChooserControl":"O1-z","disabled":"P1-z","giftCard":"Q1-z","styleChooserText":"R1-z"};